module.exports = __webpack_public_path__ + "static/media/alert.aab3f7ea.mp3";